export type { DefaultDurations } from '../../../shared/lib/blockRanges'

export type ResizeHandle = 'left' | 'travel-work' | 'work-departure' | 'right'

export interface GhostState {
  technicianId: string
  anfahrtStartIso: string
  committed?: boolean
}

export const DEFAULT_DURATIONS = {
  plannedTravelDuration: 30,
  plannedWorkDuration: 60,
  plannedDepartureDuration: 30,
}
